/**
 * Página de resultados uniforme. El BFF usa formas distintas según el recurso
 * (vacantes: `{items,total}`, usuarios: `{users,totalCount,totalPages}`); cada servicio la adapta a ésta.
 */
export interface PagedResult<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

export const emptyPage = <T>(page = 1, pageSize = 10): PagedResult<T> => ({ items: [], total: 0, page, pageSize });
